export const PERMISSION_ACTION_IMPERSONATE = 20;
